import { render, staticRenderFns } from "./SideScroller.vue?vue&type=template&id=2bbd6b9c&scoped=true"
import script from "./SideScroller.vue?vue&type=script&lang=js"
export * from "./SideScroller.vue?vue&type=script&lang=js"
import style0 from "./SideScroller.vue?vue&type=style&index=0&id=2bbd6b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd6b9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
